<div class="container-fluid alone full-height">
    <div class="row">
      <div class="col-6">
        <h3 class="section-title mb-2">
            {{ 'CONSUMPTION.CONSUMPTION.HAND_DISINFECTANT' | translate }}
        </h3>
      </div>
      <div class="col-6">
        <ul class="advise-container d-flex justify-content-end">
            <li> {{formdata.year}} </li>
            <li> | </li>
            <li> {{formdata.wardID.wardName | translate | labelSanitizer}} </li>
            <li> | </li>
            <li> {{formdata.departmentID.departmentName | translate | labelSanitizer}} </li>
        </ul>
      </div>
    </div>
  </div>
<form [formGroup]="consumptionQuarterPeriodForm">
    <table>
        <thead>

            <tr *ngFor="let data of consumptionConfigDetail">
                <th scope="col">{{'CONFIGURE.PERIOD_1' | translate}}
                    <span class="italicFont"> {{'CONSUMPTION.IN_QUARTERS' | translate}}</span>
                </th>
                <th class="border-left" scope="col"> {{ amountMeasure() }}
                    <span class="italicFont"> {{unitMeasure()}}</span>
                </th>
                <th class="border-left" scope="col">{{'CONSUMPTION.PATIENT_DAYS' | translate}}
                    <span class="italicFont"> {{"CONSUMPTION.IN_DAYS" |translate}}</span>
                </th>
                <th *ngIf="haiEnabled" class="border-left" scope="col">{{'CONSUMPTION.HAI' | translate}}
                    <span class="italicFont"> {{'CONSUMPTION.OCCURRENCES' | translate}}</span>
                </th>
            </tr>
        </thead>
        <tbody formArrayName="items" *ngFor="let item of getControls(consumptionQuarterPeriodForm, 'items'); let i = index;">
            <tr [formGroupName]="i">
                <td>{{ 'CONFIGURE.QUARTER' | translate }} {{i+1}}</td>
                <td>
                  <input *ngIf="isLiters()" type="text" onlynumber=true class="form-control" min="0" [mask]="'separator.2'" [thousandSeparator]="''" [dropSpecialCharacters]="false" formControlName="consumptionValue">
                  <input *ngIf="isMilliliters()" type="text" onlynumber=true class="form-control" min="0" mask="00000000" formControlName="consumptionValue">
                </td>
                <td>
                  <input type="text" onlynumber=true class="form-control" min="0" mask="00000000" formControlName="patientDays">
                </td>
                <td *ngIf="haiEnabled">
                  <input type="text" onlynumber=t rue class="form-control" min="0" mask="00000000" formControlName="haiOccurrences">
                </td>
            </tr>
        </tbody>
    </table>

    <div class="d-flex justify-content-end buttons-box">
        <button class="btn btn-cancel-bordered-bd mr-4" (click)="cancelConsupmtionPeriod()">{{ translationKeys.Authorization.Cancel | translate }}</button>
        <button class="btn-bd" (click)="saveConsupmtionPeriod($event)">{{ 'AUTHORIZATION.SUBMIT' | translate }}</button>
     </div>
</form>
